import React, {useEffect, useRef} from 'react';

const ModelSlider = ({onClose, title, message}) => {
    const modalRef = useRef(null);

    const handleOutsideClick = (e) => {
        if (modalRef.current && !modalRef.current.contains(e.target)) {
            onClose();
        }
    };

    useEffect(() => {
        document.body.style.overflow = 'hidden'; // Disable scrolling on the body when the modal is open
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.body.style.overflow = 'auto'; // Re-enable scrolling on the body when the modal is closed
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    console.log('message.typeof ', typeof (message))

    return (
        <div>
            <div className="modal-overlay"></div>

            <div className="modal fade show" tabIndex="-1" role="dialog" style={{display: 'block'}}>
                <div className="modal-dialog modal-dialog-centered p-3 py-5" ref={modalRef}>
                    <div className="modal-content">
                        <div className="container d-flex flex-column p-4">
                            <span className="fw-bold h6 text-pink mb-2">TeamLewis</span>

                            <span className="fs-1 text-white mb-3">
                                {title}
                            </span>

                            {
                                typeof (message) === 'object' ?
                                    <div id="carouselExampleControls" className="carousel slide"
                                         data-bs-ride="carousel">
                                        <div className="carousel-inner">

                                            {message.map((eventImage, index) => (
                                                <div className={`carousel-item ${index === 0 ? 'active' : ''}`}
                                                     key={index}>
                                                    <img src={eventImage} className="d-block w-100" alt=""/>
                                                </div>
                                            ))}

                                        </div>

                                        <button className="carousel-control-prev" type="button"
                                                data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                            <span className="visually-hidden">Previous</span>
                                        </button>
                                        <button className="carousel-control-next" type="button"
                                                data-bs-target="#carouselExampleControls" data-bs-slide="next">
                                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                            <span className="visually-hidden">Next</span>
                                        </button>
                                    </div>
                                    :
                                    <div className="carousel-item d-flex justify-content-center active">
                                        <img src={message} className="d-block w-75" alt="image"/>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModelSlider;
